import React, { createContext, useContext, useState } from 'react';
import { EvaluationCriteria } from '@/types/employeeEvaluations';

interface EvaluationCriteriaDialogContextType {
  isOpen: boolean;
  editingCriteria: EvaluationCriteria | null;
  openAddCriteria: () => void;
  openEditCriteria: (criteria: EvaluationCriteria) => void;
  closeCriteriaDialog: () => void;
}

const EvaluationCriteriaDialogContext = createContext<EvaluationCriteriaDialogContextType | undefined>(undefined);

export const EvaluationCriteriaDialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingCriteria, setEditingCriteria] = useState<EvaluationCriteria | null>(null);

  const openAddCriteria = () => {
    setEditingCriteria(null);
    setIsOpen(true);
  };

  const openEditCriteria = (criteria: EvaluationCriteria) => {
    setEditingCriteria(criteria);
    setIsOpen(true);
  };

  const closeCriteriaDialog = () => {
    setIsOpen(false);
    setEditingCriteria(null);
  };

  return (
    <EvaluationCriteriaDialogContext.Provider 
      value={{ 
        isOpen, 
        editingCriteria, 
        openAddCriteria, 
        openEditCriteria, 
        closeCriteriaDialog 
      }}
    >
      {children}
    </EvaluationCriteriaDialogContext.Provider>
  );
};

export const useEvaluationCriteriaDialog = () => {
  const context = useContext(EvaluationCriteriaDialogContext);
  if (context === undefined) {
    throw new Error('useEvaluationCriteriaDialog must be used within a EvaluationCriteriaDialogProvider');
  }
  return context;
};
